/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Filter properties specific to carrier delivery notes (includes carrierNumberPlateIncoming)
 */
export enum CarrierDeliveryNotesFilterProperties {
  Number = 'number',
  FileName = 'fileName',
  TourNumber = 'tourNumber',
  OrderNumber = 'orderNumber',
  ConsignorName = 'consignorName',
  CarrierName = 'carrierName',
  ConsigneeName = 'consigneeName',
  OriginalConsignor = 'originalConsignor',
  OriginalConsignorGln = 'originalConsignorGln',
  DeliveryNoteBundleNumber = 'deliveryNoteBundleNumber',
  Discrepancies = 'discrepancies',
  PalletTickets = 'palletTickets',
  DeliveryNoteBundleStatus = 'deliveryNoteBundleStatus',
  Status = 'status',
  DateCreated = 'dateCreated',
  DateAnnounced = 'dateAnnounced',
  CheckoutDate = 'checkoutDate',
  CheckinDate = 'checkinDate',
  Properties = 'properties',
  PropertiesReferenceNumber = 'properties.referenceNumber',
  CarrierNumberPlateOutgoing = 'carrierNumberPlateOutgoing',
  CarrierNumberPlateIncoming = 'carrierNumberPlateIncoming'
}
